export default __webpack_public_path__ + "static/media/DSTitleMediumRegular.6b96c55d.otf";